var _path, _path2, _path3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJavaLanguageIcon = function SvgJavaLanguageIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#b4b9c0",
    strokeLinecap: "round",
    strokeWidth: 1.3,
    d: "M10 2.5c1.6 1.3-.6 2.4 0 3.7m3-3.4c1.4 1.2-.5 2.2 0 3.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#16181c",
    d: "M6.5 8.5h9v4.2a3 3 0 0 1-3 3h-3a3 3 0 0 1-3-3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#16181c",
    strokeWidth: 1.2,
    d: "M15.5 9.6h1.3a1.5 1.5 0 0 1 0 3h-1.3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 1.5,
    x: 6,
    y: 17.2,
    fill: "#16181c",
    rx: 0.75
  })));
};
export default SvgJavaLanguageIcon;